<script>
export default {
  name: 'ConversaCard',
  props: {
    conversa: { type: Object, required: true },
  },
  emits: ['click', 'dragstart', 'dragend'],
  computed: {
    contato() {
      return this.conversa.contato || this.conversa.Contato || null;
    },
    nomeContato() {
      const c = this.contato;
      if (!c) return `Contato #${this.conversa.contato_id}`;
      const nome = String(c.nome || '').trim();
      const sobrenome = String(c.sobrenome || '').trim();
      if (nome && sobrenome) return `${nome} ${sobrenome}`;
      if (nome) {
        const partes = nome.split(/\s+/).filter(Boolean);
        if (partes.length >= 2) return `${partes[0]} ${partes[partes.length - 1]}`;
        return nome;
      }
      if (c && c.id) return `Contato #${c.id}`;
      return `Contato #${this.conversa.contato_id}`;
    },
    cabecalhoContato() {
      const nome = this.nomeContato || '';
      const matchWhatsapp = nome.match(/^(whatsapp)\s+(\+?\d[\d\s()-]*)$/i);
      if (matchWhatsapp) {
        return {
          principal: 'WhatsApp',
          secundarioInline: '',
          telefoneAbaixo: this._formatarTelefone(matchWhatsapp[2]) || this.telefoneFormatado,
        };
      }
      return {
        principal: nome,
        secundarioInline: '',
        telefoneAbaixo: this.telefoneFormatado,
      };
    },
    telefoneFormatado() {
      const c = this.contato;
      const canais = Array.isArray(c?.canais) ? c.canais : [];
      const tel = canais.find((x) => x.tipo_canal === 'telefone' && x.principal)
        || canais.find((x) => x.tipo_canal === 'telefone');
      const nome = String(c?.nome || '').trim();
      const matchWhatsapp = nome.match(/^(?:whatsapp)\s+(\+?\d[\d\s()-]*)$/i);
      const valor = tel?.valor_canal
        || tel?.normalizado
        || c?.telefone
        || (matchWhatsapp ? matchWhatsapp[1] : '')
        || '';
      return this._formatarTelefone(valor);
    },
    horario() {
      const data = this.conversa.ultima_mensagem_em || this.conversa.updated_at;
      if (!data) return '';
      try {
        return new Date(data).toLocaleString('pt-BR', { hour: '2-digit', minute: '2-digit', day: '2-digit', month: '2-digit' });
      } catch (_e) { return ''; }
    },
    atendente() { return this.conversa.atendente || this.conversa.Usuario || null; },
    statusConsentimento() {
      // 'opt_in' | 'opt_out' | 'pendente' | 'expirado' (default 'pendente')
      return this.conversa.status_consentimento || 'pendente';
    },
    badgeConsentimento() {
      const map = {
        opt_in:    { texto: 'Opt-in',     classe: 'bg-success-subtle text-success',         icone: 'ri-check-line' },
        opt_out:   { texto: 'Opt-out',    classe: 'bg-danger-subtle text-danger',           icone: 'ri-forbid-line' },
        pendente:  { texto: 'Pendente',   classe: 'bg-warning-subtle text-warning',         icone: 'ri-question-line' },
        expirado:  { texto: 'Expirado',   classe: 'bg-secondary-subtle text-secondary',     icone: 'ri-history-line' },
      };
      return map[this.statusConsentimento] || map.pendente;
    },
    /**
     * Prévia da última mensagem (estilo WhatsApp Web).
     * Trunca em ~60 chars, prefixa direção, traduz tipos de mídia.
     */
    previaUltimaMensagem() {
      const m = this.conversa.ultima_mensagem;
      if (!m) return '';
      let texto = m.conteudo || '';
      if (!texto) {
        const mapaTipo = {
          imagem: '📷 Imagem',
          audio: '🎤 Áudio',
          video: '🎬 Vídeo',
          documento: '📄 Documento',
          template: '📋 Template',
          sistema: '⚙️ Sistema',
        };
        texto = mapaTipo[m.tipo] || `[${m.tipo}]`;
      }
      texto = texto.replace(/\s+/g, ' ').trim();
      if (texto.length > 60) texto = `${texto.slice(0, 60)}…`;
      return texto;
    },
    iconePreviaDirecao() {
      const m = this.conversa.ultima_mensagem;
      if (!m) return null;
      if (m.direcao === 'saida') return 'ri-reply-line';
      if (m.direcao === 'sistema') return 'ri-information-line';
      return null; // entrada não precisa de ícone
    },
    etiquetasContato() {
      const c = this.contato || {};
      const lista = c.rotulos || c.Rotulo || [];
      return lista.map((r) => ({
        id: r.id,
        nome: r.nome,
        cor: r.cor_referencia || '#6c757d',
      }));
    },
    horarioRelativo() {
      const data = this.conversa.ultima_mensagem_em || this.conversa.updated_at;
      if (!data) return '';
      try {
        const d = new Date(data);
        const agora = Date.now();
        const diffMin = Math.floor((agora - d.getTime()) / 60000);
        if (diffMin < 1) return 'agora';
        if (diffMin < 60) return `${diffMin} min`;
        const diffHoras = Math.floor(diffMin / 60);
        if (diffHoras < 24) return `${diffHoras}h`;
        const diffDias = Math.floor(diffHoras / 24);
        if (diffDias < 7) return `${diffDias}d`;
        return d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' });
      } catch (_e) { return ''; }
    },
  },
  methods: {
    _formatarTelefone(valor) {
      const texto = String(valor || '').trim();
      if (!texto) return '';
      const digitos = texto.replace(/\D/g, '');
      const matchComPais = digitos.match(/^(\d{2})(\d{2})(\d{4,5})(\d{4})$/);
      if (matchComPais) return `(${matchComPais[2]}) ${matchComPais[3]}-${matchComPais[4]}`;
      const matchBrasil = digitos.match(/^(\d{2})(\d{4,5})(\d{4})$/);
      if (matchBrasil) return `(${matchBrasil[1]}) ${matchBrasil[2]}-${matchBrasil[3]}`;
      return texto;
    },
    onDragStart(event) {
      event.dataTransfer.effectAllowed = 'move';
      event.dataTransfer.setData('text/plain', String(this.conversa.id));
      this.$emit('dragstart', this.conversa);
    },
    onDragEnd() { this.$emit('dragend', this.conversa); },
  },
};
</script>

<template>
  <div
    class="conversa-card"
    draggable="true"
    @dragstart="onDragStart"
    @dragend="onDragEnd"
    @click="$emit('click', conversa)"
  >
    <!-- Linha 1: nome + horário relativo + badge não-lidas -->
    <div class="d-flex justify-content-between align-items-start gap-2">
      <div class="text-truncate">
        <strong class="text-truncate">{{ cabecalhoContato.principal }}</strong>
        <small v-if="cabecalhoContato.secundarioInline" class="telefone-inline ms-1">
          {{ cabecalhoContato.secundarioInline }}
        </small>
      </div>
      <div class="d-flex align-items-center gap-1 flex-shrink-0">
        <small class="text-muted">{{ horarioRelativo }}</small>
        <span v-if="conversa.nao_lidas_count > 0" class="badge rounded-pill bg-danger">
          {{ conversa.nao_lidas_count }}
        </span>
      </div>
    </div>

    <div v-if="cabecalhoContato.telefoneAbaixo" class="telefone-contato text-truncate">
      {{ cabecalhoContato.telefoneAbaixo }}
    </div>

    <!-- Linha 2: prévia da última mensagem (estilo WhatsApp Web) -->
    <div v-if="previaUltimaMensagem" class="previa-mensagem text-truncate" :title="previaUltimaMensagem">
      <i v-if="iconePreviaDirecao" :class="`${iconePreviaDirecao} me-1`"></i>{{ previaUltimaMensagem }}
    </div>

    <!-- Linha 3: badges (consentimento, atendente) -->
    <div class="d-flex align-items-center gap-1 flex-wrap mt-1">
      <span class="badge" :class="badgeConsentimento.classe" :title="`Consentimento: ${badgeConsentimento.texto}`">
        <i :class="`${badgeConsentimento.icone} me-1`"></i>{{ badgeConsentimento.texto }}
      </span>
      <span v-if="atendente" class="badge atendente-badge" :title="`Atendente: ${atendente.nome || atendente.name || atendente.id}`">
        <i class="ri-user-line me-1"></i>{{ (atendente.nome || atendente.name || `#${atendente.id}`).split(' ')[0] }}
      </span>
      <span v-else class="badge sem-atendente-badge" title="Sem atendente atribuído">
        <i class="ri-user-add-line me-1"></i>Livre
      </span>
    </div>

    <!-- Etiquetas do contato (na base do card) -->
    <div v-if="etiquetasContato.length" class="etiquetas-card mt-2">
      <span
        v-for="e in etiquetasContato"
        :key="e.id"
        class="badge etiqueta-pill"
        :style="{ backgroundColor: e.cor }"
        :title="e.nome"
      >
        {{ e.nome }}
      </span>
    </div>
  </div>
</template>

<style scoped>
.conversa-card {
  background: var(--vz-body-bg);
  border: 1px solid var(--vz-border-color);
  color: var(--vz-body-color);
  border-radius: 0.5rem;
  padding: 0.6rem 0.75rem;
  margin-bottom: 0.5rem;
  cursor: grab;
  box-shadow: 0 1px 2px rgba(0,0,0,0.08);
  transition: box-shadow 0.15s, transform 0.15s;
  user-select: none;
}
.conversa-card:hover {
  box-shadow: 0 4px 12px rgba(0,0,0,0.18);
  transform: translateY(-1px);
}
.conversa-card:active { cursor: grabbing; }

.previa-mensagem {
  color: var(--vz-secondary-color);
  font-size: 0.8125rem;
  margin-top: 0.2rem;
  margin-bottom: 0.35rem;
  line-height: 1.3;
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.telefone-contato {
  color: var(--vz-secondary-color);
  font-size: 0.75rem;
  line-height: 1.2;
  margin-top: 0.1rem;
}

.sem-atendente-badge {
  background: var(--vz-warning-bg-subtle);
  color: var(--vz-warning-text-emphasis);
}

.etiquetas-card {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
  padding-top: 0.5rem;
  border-top: 1px dashed var(--vz-border-color);
}

.etiqueta-pill {
  color: #fff;
  font-weight: 500;
  font-size: 0.7rem;
  padding: 0.18rem 0.5rem;
  border-radius: 0.85rem;
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.atendente-badge {
  background: var(--vz-secondary-bg-subtle);
  color: var(--vz-secondary-color);
  border: 1px solid var(--vz-border-color);
}

[data-bs-theme='dark'] .conversa-card {
  box-shadow: 0 1px 3px rgba(0,0,0,0.4);
}
[data-bs-theme='dark'] .conversa-card:hover {
  box-shadow: 0 4px 14px rgba(0,0,0,0.55);
}
</style>
